  import React from "react";
  import { AppBar, Toolbar, Box, useMediaQuery } from "@mui/material";
  import { useTheme } from "@mui/material/styles";
  import { useLocation } from "react-router-dom";
  import PageHeader from "../page-layout/PageHeader";

  const MobileHeader = ({ title, lead, actions, showBack }) => {
    const theme = useTheme();
    const location = useLocation();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isDark = theme.palette.mode === "dark";

    // Hide on login page
    if (location.pathname === "/login") return null;

    return (
      <AppBar
        position="fixed"
        sx={{
          top: 0,
          left: 0,
          right: 0,
          bgcolor: isDark ? theme.palette.background.default : "#00245E",
          color: "#fff",
          zIndex: 1200,
          pl: 2, // ✅ Reduced horizontal padding
          height: { xs: 48, md: "auto" }, // ✅ Changed from 64 to 48
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        elevation={1}
      >
        <Box
          sx={{
            width: "100%",
            transform: { xs: "center", md: "none" }, // ✅ Removed vertical shift
          }}
        >
          <PageHeader
            title={title}
            lead={lead}
            rightComponent={actions}
            showBack={showBack}
            isMobileHeader={true} // ✅ Pass flag to reduce padding in PageHeader
          />
        </Box>
      </AppBar>
    );
  };

  export default MobileHeader;
